export default __webpack_public_path__ + "static/media/img2.ab06ae27.JPG";